import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationListModule } from '@portal-core/notifications/components/notification-list/notification-list.module';
import { TranslationPackageLanguageBranchNotificationListComponent } from './translation-package-language-branch-notification-list.component';

@NgModule({
  declarations: [
    TranslationPackageLanguageBranchNotificationListComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    NotificationListModule
  ],
  exports: [
    TranslationPackageLanguageBranchNotificationListComponent
  ]
})
export class TranslationPackageLanguageBranchNotificationListModule { }
